import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvestmentsinline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M6.875 15.375H3.333a.71.71 0 0 1-.708-.708v-2.833c0-.392.317-.708.708-.708h3.542"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M11.125 3.333v12.042h3.541a.71.71 0 0 0 .708-.708V3.333a.71.71 0 0 0-.708-.708h-2.833a.71.71 0 0 0-.708.708",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.15,
			d: "M11.125 15.375h-4.25V7.583c0-.391.317-.708.708-.708h3.541"
		})
	]
});
export default SvgInvestmentsinline;
